import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorExplore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z"
    />
    <path
      fill="#F7A600"
      d="m10.995 10.995 3.076-1.066-1.066 3.076-3.076 1.066 1.066-3.076ZM10 9.753a.4.4 0 0 0-.247.247L7.77 15.72a.4.4 0 0 0 .509.51L14 14.246a.4.4 0 0 0 .247-.247L16.23 8.28a.4.4 0 0 0-.509-.51L10 9.754Z"
    />
  </svg>
);
export default SvgTwoColorExplore;
